import styled from "styled-components";
import { Dropdown } from "react-bootstrap";

export const AddressCardItem = styled.div`
  background-color: #ffffff;
  width: 100%;
  max-width: 100%;
  height: auto;
  padding: 5px 10px;
  display: flex;
  flex-direction: row;
  border-radius: 16px;
  align-items: center;
  justify-content: space-between;
  justify-content: flex-start;
`;

export const AddressInfo = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 0.5rem;
  width: 100%;
`;

export const AddressText = styled.span`
  font-size: 75%;
  font-weight: 400;
  color: #808080;
  width: 100%;
  text-align: left;
  white-space: normal;
`;

export const AddressCard = styled.div`
  //display: flex;
`;

export const DropdownWidth = {
  minWidth: "100%",
};

export const DropdownMenuEconomic = styled(Dropdown.Menu)`
  max-height: 300px;
  overflow: auto;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  border-width: 0px;
  box-shadow: 0px 18px 17px 3px #00000066;
  width: 100%;
  background: white;
  top: -10px !important;

  @media(min-width: 1000px) and (max-width: 1300px) {
    top: -40px !important;
  }

  @media(max-width: 770px) {
    top: ${(props) => props.lapidar ? "-40px !important" : "0px !important"};
  }

  @media(max-width: 1000px) {
    width: 100%;
  }

  @media only screen  and (max-width: 359px) {
    transform: translate(0px, 100px) !important;
  }

  @media (min-width: 359px) and (max-width: 770px) {
    transform: translate(0px, 93px) !important;
  }

  @media (min-width: 771px) and (max-width: 999px){
    transform: translate(0px, 62px) !important;
  }

  @media (min-width: 1000px) and (max-width: 1300px) {
    transform: translate(0px, 92px) !important;
  }

  @media only screen and (min-width: 1301px) {
    transform: translate(0px, 67px) !important;
  }

  @media (min-width: 1000px) and (max-width: 1300px) {
    transform: translate(0px, 92px) !important;
  }

  @media only screen and (min-width: 1301px) {
    transform: translate(0px, 67px) !important;
  }

`;

export const DrodownButtonEconomic = {
  backgroundColor: "transparent",
  borderColor: "transparent",
  padding: 0,
  borderWidth: 0,
  maxWidth: 300,
};

export const DropdownItemEconomic = {
  paddingLeft: 10,
  paddingRight: 10,
};

export const RadioButtonEconomic = {
  padding: 0,
};
